<!-- Chip Content -->
<p-chip [title]="tooltipLabel"
        [styleClass]="styleClass">
  <ng-content></ng-content>
</p-chip>